export default __webpack_public_path__ + "static/media/error-part.d24adbcd.svg";